export default __webpack_public_path__ + "static/media/IC00025-events_org.1733f2a5.svg";